import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { FullThreadDto } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetThreadById = ({
    threadId,
    enabled,
}: {
    threadId?: string;
    enabled: boolean;
}): UseQueryResult<FullThreadDto> => {
    return useQuery({
        enabled: !!threadId && enabled,
        queryKey: aiAgentQueryKeys.threadById(threadId as string),
        staleTime: 0,
        refetchOnMount: true,
        queryFn: ({ signal }) => {
            return salesApiService.aiAgent.meeting.getThreadById(threadId as string, { cancellation: signal });
        },
    });
};
